import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { isAuthenticated, getUserRole } from '../utils/auth';

const WAITLIST_FORM_URL = 'https://docs.google.com/forms/d/e/1FAIpQLSdOTbdUlQqWULdzFJq3p5BhzcJzZpovMESnv52iyhdap2qJCA/viewform';

function WelcomePage() {
  const navigate = useNavigate();
  const [expandedImage, setExpandedImage] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 900);

  // Handle resize
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 900);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // If already authenticated, redirect to appropriate dashboard
  useEffect(() => {
    if (isAuthenticated()) {
      const role = getUserRole();
      if (role === 'teacher') {
        navigate('/teacher/dashboard');
      } else {
        navigate('/student/classes');
      }
    }
  }, [navigate]);

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
      display: 'flex',
      flexDirection: 'column'
    }}>
      {/* Top Navigation Bar */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: isMobile ? '16px 20px' : '20px 40px',
        background: 'rgba(255,255,255,0.8)',
        backdropFilter: 'blur(10px)',
        borderBottom: '1px solid rgba(0,0,0,0.05)',
        position: 'sticky',
        top: 0,
        zIndex: 100
      }}>
        {/* Logo */}
        <div>
          <img
            src="/mataabiline logo.png"
            alt="Mataabiline"
            style={{
              height: isMobile ? '36px' : '44px',
              width: 'auto',
              borderRadius: '8px'
            }}
          />
        </div>

        {/* Waitlist Button */}
        <button
          onClick={() => window.open(WAITLIST_FORM_URL, '_blank')}
          style={{
            padding: isMobile ? '10px 16px' : '12px 24px',
            borderRadius: '8px',
            background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
            color: 'white',
            border: 'none',
            fontWeight: '600',
            fontSize: isMobile ? '13px' : '15px',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'translateY(-1px)';
            e.currentTarget.style.boxShadow = '0 6px 16px rgba(59, 130, 246, 0.4)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(59, 130, 246, 0.3)';
          }}
        >
          Liitu ootenimekirjaga
        </button>
      </div>

      {/* Main Content */}
      <div style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: isMobile ? '24px 16px' : '40px',
        overflowY: 'auto'
      }}>
        {/* Headline */}
        <h1 style={{
          fontSize: isMobile ? '24px' : 'min(4vw, 36px)',
          fontWeight: '700',
          color: '#1e3a5f',
          textAlign: 'center',
          marginBottom: '8px',
          lineHeight: '1.2',
          padding: '0 16px'
        }}>
          AI tööriist, mis aitab lastel paremini matemaatikat õppida
        </h1>

        {/* Subheadline */}
        <p style={{
          fontSize: isMobile ? '15px' : 'min(2vw, 18px)',
          color: '#64748b',
          textAlign: 'center',
          marginBottom: isMobile ? '24px' : '40px',
          maxWidth: '600px',
          padding: '0 16px'
        }}>
          Lahenda ülesandeid, saa kohest tagasisidet ja õpi vigadest
        </p>

        {/* Three Images Section */}
        <div style={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          gap: isMobile ? '24px' : 'min(3vw, 32px)',
          justifyContent: 'center',
          alignItems: isMobile ? 'center' : 'flex-start',
          width: '100%',
          maxWidth: '1200px',
          padding: '0 16px'
        }}>
          {/* IMAGE 1 */}
          <div style={{
            textAlign: 'center',
            flex: isMobile ? 'none' : '1',
            width: isMobile ? '100%' : 'auto',
            maxWidth: isMobile ? '400px' : '360px'
          }}>
            <div
              onClick={() => setExpandedImage('/landing_page1.jpeg')}
              style={{
                borderRadius: '16px',
                overflow: 'hidden',
                marginBottom: '12px',
                boxShadow: '0 8px 30px rgba(0,0,0,0.12)',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                background: 'white'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 12px 40px rgba(0,0,0,0.15)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 8px 30px rgba(0,0,0,0.12)';
              }}
            >
              <img
                src="/landing_page1.jpeg"
                alt="Ülesanne"
                style={{ width: '100%', height: 'auto', display: 'block' }}
              />
            </div>
            <div style={{
              background: 'white',
              borderRadius: '8px',
              padding: '8px 16px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
            }}>
              <span style={{
                fontSize: '13px',
                fontWeight: '600',
                color: '#3b82f6'
              }}>1.</span>
              <span style={{
                fontSize: '13px',
                color: '#475569',
                marginLeft: '6px'
              }}>Õpilane avab ülesande</span>
            </div>
          </div>

          {/* IMAGE 2 */}
          <div style={{
            textAlign: 'center',
            flex: isMobile ? 'none' : '1',
            width: isMobile ? '100%' : 'auto',
            maxWidth: isMobile ? '400px' : '360px'
          }}>
            <div
              onClick={() => setExpandedImage('/landing_page2.jpeg')}
              style={{
                borderRadius: '16px',
                overflow: 'hidden',
                marginBottom: '12px',
                boxShadow: '0 8px 30px rgba(0,0,0,0.12)',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                background: 'white'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 12px 40px rgba(0,0,0,0.15)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 8px 30px rgba(0,0,0,0.12)';
              }}
            >
              <img
                src="/landing_page2.jpeg"
                alt="Lahendus"
                style={{ width: '100%', height: 'auto', display: 'block' }}
              />
            </div>
            <div style={{
              background: 'white',
              borderRadius: '8px',
              padding: '8px 16px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
            }}>
              <span style={{
                fontSize: '13px',
                fontWeight: '600',
                color: '#3b82f6'
              }}>2.</span>
              <span style={{
                fontSize: '13px',
                color: '#475569',
                marginLeft: '6px'
              }}>Õpilane lahendab ülesande</span>
            </div>
          </div>

          {/* IMAGE 3 */}
          <div style={{
            textAlign: 'center',
            flex: isMobile ? 'none' : '1',
            width: isMobile ? '100%' : 'auto',
            maxWidth: isMobile ? '400px' : '360px'
          }}>
            <div
              onClick={() => setExpandedImage('/landing_page3.jpeg')}
              style={{
                borderRadius: '16px',
                overflow: 'hidden',
                marginBottom: '12px',
                boxShadow: '0 8px 30px rgba(0,0,0,0.12)',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                background: 'white'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 12px 40px rgba(0,0,0,0.15)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 8px 30px rgba(0,0,0,0.12)';
              }}
            >
              <img
                src="/landing_page3.jpeg"
                alt="Tagasiside"
                style={{ width: '100%', height: 'auto', display: 'block' }}
              />
            </div>
            <div style={{
              background: 'white',
              borderRadius: '8px',
              padding: '8px 16px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
            }}>
              <span style={{
                fontSize: '13px',
                fontWeight: '600',
                color: '#3b82f6'
              }}>3.</span>
              <span style={{
                fontSize: '13px',
                color: '#475569',
                marginLeft: '6px'
              }}>Õpilane saab kiiret tagasisidet</span>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer style={{
        padding: isMobile ? '16px 20px' : '20px 40px',
        background: 'rgba(255,255,255,0.8)',
        backdropFilter: 'blur(10px)',
        borderTop: '1px solid rgba(0,0,0,0.05)',
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '12px'
      }}>
        <span style={{
          fontSize: '13px',
          color: '#64748b'
        }}>
          © Mataabiline 2026
        </span>
        <div style={{ display: 'flex', gap: '20px' }}>
          <a
            href="/PRIVACY POLICY.pdf"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              fontSize: '13px',
              color: '#64748b',
              textDecoration: 'none',
              transition: 'color 0.2s ease'
            }}
            onMouseOver={(e) => e.currentTarget.style.color = '#3b82f6'}
            onMouseOut={(e) => e.currentTarget.style.color = '#64748b'}
          >
            Privaatsuspoliitika
          </a>
          <a
            href="/TERMS OF SERVICE.pdf"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              fontSize: '13px',
              color: '#64748b',
              textDecoration: 'none',
              transition: 'color 0.2s ease'
            }}
            onMouseOver={(e) => e.currentTarget.style.color = '#3b82f6'}
            onMouseOut={(e) => e.currentTarget.style.color = '#64748b'}
          >
            Kasutustingimused
          </a>
          <span
            onClick={() => navigate('/login')}
            style={{
              fontSize: '13px',
              color: '#cbd5e1',
              textDecoration: 'none',
              cursor: 'pointer',
              transition: 'color 0.2s ease'
            }}
            onMouseOver={(e) => e.currentTarget.style.color = '#64748b'}
            onMouseOut={(e) => e.currentTarget.style.color = '#cbd5e1'}
          >
            Logi sisse
          </span>
        </div>
      </footer>

      {/* Lightbox Modal */}
      {expandedImage && (
        <div
          onClick={() => setExpandedImage(null)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0,0,0,0.9)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            cursor: 'pointer',
            padding: isMobile ? '16px' : '40px'
          }}
        >
          <img
            src={expandedImage}
            alt="Suurendatud pilt"
            style={{
              maxWidth: '95%',
              maxHeight: '95%',
              borderRadius: '12px',
              boxShadow: '0 25px 80px rgba(0,0,0,0.5)',
              objectFit: 'contain'
            }}
          />
          <div style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            color: 'white',
            fontSize: '14px',
            opacity: 0.8,
            background: 'rgba(0,0,0,0.4)',
            padding: '8px 16px',
            borderRadius: '20px'
          }}>
            ✕ Sulge
          </div>
        </div>
      )}
    </div>
  );
}

export default WelcomePage;
